import "./account.css";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import FooterLinks from "../../components/FooterLinks/footerLinks.jsx";

const Account = () => {
  const navigate = useNavigate();

  const redirectToBack = () => {
    navigate(-1);
  };

  // sessionStorage.setItem('userNumber', '+971 111-111-11');//only for quick test
  const userNumber = useRef(null);
  const userSubscribeDate = useRef(null);
  const endDate = useRef(null);

  const [number, setNumber] = useState("");
  const [dateSub, setDateSub] = useState("");
  const [dateEx, setDateEx] = useState("");

  useEffect(() => {
    const userNumber =
      sessionStorage.getItem("userNumber") || "+971 xxx-xxx-xxx";
    const date_sub =
      sessionStorage.getItem("date_sub") || "20-03-2025 15:03:08";
    const date_expiry =
      sessionStorage.getItem("date_expiry") || "21-03-2025 15:03:08";

    setNumber(userNumber);
    setDateSub(date_sub);
    setDateEx(date_expiry);
  }, []);

  return (
    <section id="account" className="section">
      <div className="section">
        <div className="account__page_wrapper">
          <div className="account__page">
            <h2 className="account__page_title">My account</h2>

            <div id="account__text" className="account__page_text">
              <p>
                Mobile number: <span>{number}</span>
              </p>
              <p>
                Subscription date:
                <span> {dateSub} </span>
              </p>
              <p>
                Expiration date:
                <span> {dateEx} </span>
              </p>
            </div>

            <button className="account__page_button" onClick={redirectToBack}>
              Back
            </button>

            <p className="last__text-account">
              For any content related inquiries, please
              contact support@vassabi.com
            </p>
          </div>
        </div>
      </div>
      <FooterLinks />
    </section>
  );
};

export default Account;
